"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var waves = require("node-waves");
require("node-waves/dist/waves.css");
var React = require("react");
require("./style/Button.css");
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, onClick = _a.onClick, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut, style = _a.style, type = _a.type;
        return (React.createElement("div", { className: "Button-wrapper" },
            React.createElement("button", { ref: function (button) { return _this.button = button; }, className: className || "Button-container", onClick: onClick && (function (event) {
                    onClick();
                    event.stopPropagation();
                }), onMouseOver: onMouseOver, onMouseOut: onMouseOut, style: style, type: type }, children)));
    };
    default_1.prototype.componentDidMount = function () {
        this.componentDidUpdate();
    };
    default_1.prototype.componentDidUpdate = function () {
        if (this.button) {
            waves.attach(this.button, ["waves-light"]);
            waves.init();
        }
    };
    return default_1;
}(React.Component));
exports.default = default_1;



//////////////////
// WEBPACK FOOTER
// ./src/component/Button.tsx
// module id = 18
// module chunks = 0